export default __webpack_public_path__ + "static/media/lifesatisfaction3Img2.c7e31e82.png";